export default __webpack_public_path__ + "e1e40acdac08f65d499de529ee6cd5de.svg";